<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Últimos Acessos'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="companyId">Empresa ID</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="companyId"
                             name="companyId">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.header" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button v-on:click="searchUser()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loading && (dataUser !== '' && !dataUser.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataUser.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataUser.length }})</span>

                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> NOME</th>
                        <th> EMAIL</th>
                        <th> ÚLTIMO LOGIN</th>
                        <th> DATA DE CADASTRO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="a in dataUser">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + a.companyId + '/' + a.company.contextCode"
                               target="_blank" class="link">{{ a.company.name }}</a></td>
                        <td>{{ a.name }}</td>
                        <td>{{ a.email }}</td>
                        <td>{{ a.lastLogin | formatFullDate }}</td>
                        <td>{{ a.createdAt | formatDate }}</td>
                        <td>
                          <a v-bind:href="'/usuario/' + a.userId + '/' + dataSearch.header" title="Visualizar"
                             class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  USERS_LASTS_ACCESS
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";

export default {
  name: "last-access",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loading: false,
      failRequest: false,
      dataUser: '',
      dataSearch: {
        header: 'AAAA',
        companyId: ''
      }
    }
  },
  methods: {
    searchUser() {
      this.loading = true;

      let url = USERS_LASTS_ACCESS + "?t=kkkk";

      if (this.dataSearch.companyId)
        url += "&companyId=" + this.dataSearch.companyId;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
        UTIL_SERVICE.console("RESULT SEARCH USER:", response.data);

        this.dataUser = response.data;
        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
  beforeMount() {
    this.searchUser();
  }
}
</script>

<style lang="scss">
.link {
  color: #3598dc;
  border-bottom: 1px solid #3598dc;
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    font-weight: 600;
    text-decoration: none;
    color: #0F77AE;
    border-bottom: 1px dashed #0F77AE;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/user/lastAccess/lastAccess.vue